// language=GraphQL
export const ALL_BACKGROUND_BLOCKS_QUERY = `query Query($withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  backgroundBlocks: cmsBackgroundBlocks {
    id
    backgroundVariant
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_BACKGROUND_BLOCK_QUERY = `query Query($id: ID!, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
  backgroundBlock: cmsBackgroundBlock(id: $id) {
    id
    backgroundVariant
    contentBlockAssignments @include(if: $withContentBlockAssignments) {
      id
      type
      block @include(if: $withContentBlockAssignmentsBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          slides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            title
            text
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            description
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            firstName
            lastName
            description
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            type
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withContentBlockAssignmentsBlockDeep) {
            id
            label
            targetBlank
            type
            url
          }

        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_BACKGROUND_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsBackgroundBlockInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    backgroundBlock: createCmsBackgroundBlock(input: $input) {
      id
      backgroundVariant
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_BACKGROUND_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsBackgroundBlockInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {
    backgroundBlock: updateCmsBackgroundBlock(input: $input) {
      id
      backgroundVariant
      contentBlockAssignments @include(if: $withContentBlockAssignments) {
        id
        type
        block @include(if: $withContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imageFixedAspectRatio
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            imagePosition

          }
          ... on CmsAccordionBlock {
            id
            items @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              content
            }

          }
          ... on CmsGridBlock {
            id
            columns @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }

          }
          ... on CmsImageBlock {
            id
            image @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id
            employees @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }

          }
          ... on CmsContactBannerBlock {
            id
            employee @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            email
            phonePrefix
            phone
            phone2Prefix
            phone2

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
            slides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              title
              text
            }

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              description
            }
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id
            travels @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
            }
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id
            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }

          }
          ... on CmsTravelGuidesBlock {
            id
            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              firstName
              lastName
              description
            }

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant
            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              type
            }

          }
          ... on CmsButtonBlock {
            id
            variant
            size
            position
            link @include(if: $withContentBlockAssignmentsBlockDeep) {
              id
              label
              targetBlank
              type
              url
            }

          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_BACKGROUND_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBackgroundBlockInput) {
    deleteCmsBackgroundBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BACKGROUND_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsBackgroundBlockInput) {
    forceDeleteCmsBackgroundBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: addCmsBackgroundBlockContentBlockAssignmentsInput) {
    addCmsBackgroundBlockContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const REMOVE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: removeCmsBackgroundBlockContentBlockAssignmentsInput) {
    removeCmsBackgroundBlockContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const CREATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: createCmsBackgroundBlockContentBlockAssignmentsInput) {
    createCmsBackgroundBlockContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const DELETE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: deleteCmsBackgroundBlockContentBlockAssignmentsInput) {
    deleteCmsBackgroundBlockContentBlockAssignments(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`

// language=GraphQL
export const UPDATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsBackgroundBlockContentBlockAssignmentsOrderInput) {
    updateCmsBackgroundBlockContentBlockAssignmentsOrder(input: $input) {
      id
      contentBlockAssignmentIds
    }
  }`
